import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: variables.white,
      justifyContent: 'space-between',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 598,
      padding: '50px 60px',
      height: 557,
      margin: `${theme.spacing(0)} auto`,

      '@media (max-width: 600px)': {
        width: '100%',
        display: 'block',
      },
    },
    successContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 598,
      padding: '50px 60px',
      height: 400,
      margin: `${theme.spacing(0)} auto`,

      '@media (max-width: 600px)': {
        width: '100%',
        display: 'block',
      },
    },
    required: {
      color: variables.red,
    },
    card: {
      width: 504,
      boxShadow: 'none',

      '& .MuiCardContent-root': {
        padding: 8,
      },

      '@media (max-width: 600px)': {
        width: 'unset',
      },
    },
    padding: {
      paddingTop: 30,
    },
    label: {
      fontSize: 14,
      fontWeight: 500,
      color: variables.policeBlue,
    },
    cardActions: {
      marginBottom: 40,
      justifyContent: 'center',
      flexDirection: 'column',
    },
    title: {
      fontWeight: 700,
      fontSize: 28,
      textAlign: 'center',
      color: variables.black,
    },
    input: {
      '& .MuiOutlinedInput-input': {
        fontSize: 14,
        color: variables.policeBlue,
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 4,
        height: 40,
      },
    },
    icon: {
      color: variables.policeBlue,
    },
    submitButton: {
      borderRadius: 4,
      height: 46,

      '&:hover': {
        backgroundColor: variables.cobaltBlue,
        color: variables.white,
      },
    },
    cancelButton: {
      marginLeft: '0px !important;',
      marginTop: 16,
      borderRadius: 4,
      height: 46,
      backgroundColor: variables.white,
      color: variables.black,
      boxShadow: 'none',

      '&:hover': {
        backgroundColor: variables.cobaltBlue,
        color: variables.white,
      },
    },
    checkIcon: {
      fontSize: 98,
      color: '#2CC67C',
    },
    successCard: {
      boxShadow: 'none',
      textAlign: 'center',
      width: 504,

      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
    successAction: {
      justifyContent: 'center',
    },
    margin: {
      marginTop: 40,
      marginBottom: 40,
    },
    specifyEmail: {
      paddingTop: 30,
      textAlign: 'center',
    },
  }),
);
